import React from 'react'
import PropTypes from 'prop-types'
import { STATUS_FINISH, STATUS_TYPES, StepName, StepsSeparator } from './StepsIndicator.styles'
import StepProgress from './StepProgress'
import StepData from './StepData'
import Flex from '../Flex'
import { STATUS_PROCESS, StepsUnfinishedCurrentTitle, StepsUnfinishedMobileTitle, StepsUnfinishedTitle } from './StepData.styles'
import Box from '../Box'

export const Step = ({ editIcon, status, title, stepCompletedTitle, stepMobileTitle, currentStep, totalSteps, nextStatus, extraInfoComponent, goToStep}) => {
    if (status === STATUS_FINISH) {
        return <StepData
            editIcon={editIcon}
            stepTitle={stepCompletedTitle}
            stepMobileTitle={stepMobileTitle}
            extraInfoComponent={extraInfoComponent}
            currentStep={currentStep}
            totalSteps={totalSteps}
            status={status}
            nextStatus={nextStatus}
            goToStep={goToStep}
        />
    }

    return <Flex width='100%' flexDirection='column' alignItems='flex-start'>
        <Box width='100%' alignItems='flex-start'>
            <StepName status={status}>
                <StepProgress
                    currentStep={currentStep}
                    totalSteps={totalSteps}
                    status={status} />
                {status === STATUS_PROCESS ? <StepsUnfinishedCurrentTitle status={status}>{ title } </StepsUnfinishedCurrentTitle>: <StepsUnfinishedTitle status={status}>{ title } </StepsUnfinishedTitle> }
                <StepsUnfinishedMobileTitle>{ stepMobileTitle }</StepsUnfinishedMobileTitle>
                {currentStep !== totalSteps && <Box flex='1' display={['none', 'none', 'block']} p='0 5px'>
                    <StepsSeparator status={status} />
                </Box>}
            </StepName>
        </Box>
    </Flex>

}

Step.propTypes = {
    editIcon: PropTypes.node,
    status: PropTypes.oneOf(STATUS_TYPES),
    nextStatus: PropTypes.oneOf(STATUS_TYPES),
    title: PropTypes.node,
    stepCompletedTitle: PropTypes.node,
    stepMobileTitle: PropTypes.node,
    currentStep: PropTypes.number,
    totalSteps: PropTypes.number,
    extraInfoComponent: PropTypes.node,
    goToStep: PropTypes.func,
}

export default Step
